/**
 *
 * FlashCardDetail
 *
 */

import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ToggleSheetBtn',

  computed: {
    ...mapGetters('FlashCard/FlashCardDetail', {
      mg_isNoCard: 'isNoCard',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
    }),

    toggleSheet() {
      this.mm_SET_MODAL_CARD_TYPE('sheet');
    },
  },
};
